/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';
import PropTypes from 'prop-types';
import { Button, FlexCol, FlexRow, Icon, Select } from 'sarsaparilla';
import get from 'lodash/get';
import toNumber from 'lodash/toNumber';
import { equipmentTypes } from '../../utils/permitUtilsNew';
import { getClassName } from '../../utils/validationUtils';
import * as types from '../../constants';

const propTypes = {
    removeWatercraft: PropTypes.func,
    handleWatercraftChange: PropTypes.func,
    isRemoveDisabled: PropTypes.bool,
    watercraft: PropTypes.any,
    permit: PropTypes.shape({
        equipments: PropTypes.array,
        divisions: PropTypes.shape({}),
    }),
    issuance: PropTypes.shape({
        id: PropTypes.string,
        division_id: PropTypes.string,
    }),
    index: PropTypes.number,
    validation: PropTypes.shape({}),
    displayValidationError: PropTypes.bool,
};

const WATERCRAFT_PROP_PATH = 'watercraft';

export default class WatercraftItem extends React.Component {
    static propTypes = propTypes;

    constructor(props) {
        super(props);
        this.onClickRemove = this.onClickRemove.bind(this);
    }

    handleChange(event) {
        let input = event.target.value;
        const id = event.target.id;
        if (!toNumber(input)) {
            input = '0';
        } else {
            input = `${parseInt(input, 10)}`;
        }
        this.props.handleWatercraftChange(this.props.index, id, input);
    }

    onClickRemove(e) {
        e.preventDefault();
        const index = parseInt(this.props.index, 10);
        this.props.removeWatercraft(index);
    }

    getWatercraftTypes() {
        const result = [];
        if (this.props.permit.equipments) {
            const div = this.props.permit.divisions[this.props.issuance.division_id];
            for (const e of this.props.permit.equipments) {
                if (e.type === types.EQUIP_TYPE_MOTORBOAT) {
                    // If Motorboat
                    if (
                        div &&
                        (div.type === types.DIV_TYPE_DM ||
                            div.type === types.DIV_TYPE_OM ||
                            div.type === types.DIV_TYPE_DC)
                    ) {
                        result.push(e);
                    }
                } else {
                    result.push(e);
                }
            }
        }

        return result.sort((a, b) => {
            const aLabel = equipmentTypes.get(a.type);
            const bLabel = equipmentTypes.get(b.type);

            if (aLabel === 'Other') return bLabel === 'Other' ? 0 : 1;
            if (bLabel === 'Other') return -1;
            return aLabel.localeCompare(bLabel);
        });
    }

    renderRemoveButton() {
        return (
            <FlexCol md={1} alignSelf="center">
                <div className="permit-form-link watercraft">
                    <Button
                        appearance="subtle-danger"
                        onClick={this.onClickRemove}
                        isDisabled={this.props.isRemoveDisabled}
                        iconBeforeElement={<Icon iconName="delete" />}
                    >
                        <span className={'rec-sr-only'}>Remove watercraft type</span>
                        Delete
                    </Button>
                </div>
            </FlexCol>
        );
    }

    render() {
        // TODO: work on validations for this component in a way that wont heavily impact performance
        const {
            issuance: { id },
            validation,
            displayValidationError,
            index,
        } = this.props;

        const watercraftTypeFailValidation = getClassName(
            get(validation, `${id}_${WATERCRAFT_PROP_PATH}[${index}].type`),
            displayValidationError
        );
        const watercraftQtyFailValidation = getClassName(
            get(validation, `${id}_${WATERCRAFT_PROP_PATH}[${index}].qty`),
            displayValidationError
        );

        const watercraftTypes = this.getWatercraftTypes();
        return (
            <FlexRow alignItems="end">
                <FlexCol md={3}>
                    <div className="rec-form-item-wrap">
                        <Select
                            label="Type"
                            isRequired
                            className={`watercraft-type ${watercraftTypeFailValidation}`}
                            name="watercraft-type"
                            id="watercraft-type"
                            value={this.props.watercraft?.type?.toString() || ''}
                            required
                            onChange={(e) => {
                                this.handleChange(e);
                            }}
                        >
                            <option value="">Select from list</option>
                            {watercraftTypes.map((x) => (
                                <option key={x.type} value={x.type}>
                                    {equipmentTypes.get(x.type)}
                                </option>
                            ))}
                        </Select>
                        {/* <CustomValidation
              value={parseInt(get(this.props, 'watercraft.type', 0) || 0, 10)}
              displayInSummary
              customValidator={(type) => type === 0}
              onValidated={(isInValid, error) => onFormValidate(isInValid, error, `${WATERCRAFT_PROP_PATH}[${index}].type`)}
              controlLabel="Watercraft Type" >
              <ValidationMessage controlName="Watercraft Type" message="is required." />
            </CustomValidation> */}
                    </div>
                </FlexCol>
                <FlexCol md={2}>
                    <div className="rec-form-item-wrap">
                        <label htmlFor="watercraft-amount">
                            Quantity
                            <mark title="required">*</mark>
                        </label>
                        <input
                            type="number"
                            className={`watercraft-amount ${watercraftQtyFailValidation}`}
                            id="watercraft-amount"
                            min="0"
                            value={this.props.watercraft.amount}
                            onChange={(e) => {
                                this.handleChange(e);
                            }}
                        />
                        {/* <CustomValidation
              value={parseInt(get(this.props, 'watercraft.amount', 0), 10)}
              displayInSummary
              customValidator={(type) => !type}
              onValidated={(isInValid, error) => onFormValidate(isInValid, error, `${WATERCRAFT_PROP_PATH}[${index}].qty`)}
              controlLabel="Watercraft Quantity" >
              <ValidationMessage controlName="Watercraft Quantity" message="is required." />
            </CustomValidation> */}
                    </div>
                </FlexCol>
                {this.renderRemoveButton()}
            </FlexRow>
        );
    }
}
